import { render, staticRenderFns } from "./PaymentsCompanies.vue?vue&type=template&id=409b04b9"
import script from "./PaymentsCompanies.vue?vue&type=script&lang=js"
export * from "./PaymentsCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports